var _ellipse, _ellipse2, _g, _path, _path2, _path3, _path4, _ellipse3, _g2, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotPassSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 177,
    viewBox: "0 0 250 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 88.0952,
    rx: 112.069,
    ry: 66.2066,
    fill: "#E5E7F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_225_18479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 21,
    width: 226,
    height: 134
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.001,
    cy: 88.0952,
    rx: 112.069,
    ry: 66.2066,
    fill: "#E5E7F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_225_18479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2503 138.986L27.2566 138.982C24.4399 132.214 27.1235 124.407 33.5122 120.78L65.7399 101.679C72.7913 97.6768 81.7515 100.186 85.6702 107.27L85.7734 107.462C89.6541 114.463 87.126 123.278 80.1262 127.182L47.789 146.094C40.1887 150.33 30.5906 147.012 27.2503 138.986Z",
    fill: "#FFEBD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.8801 251.721C-63.7368 245.834 -61.3944 240.727 -60.1909 239.062L-22.2848 187.331C-21.7442 186.58 -21.0534 185.944 -20.2522 185.481L62.9542 139.844C64.4958 138.946 66.0931 136.682 64.776 134.614C61.8152 129.967 55.1644 116.876 52.1883 111.597C50.9662 109.429 48.6975 109.785 46.9704 110.804L-42.2176 160.418C-42.9201 160.828 -43.5355 161.372 -44.0419 162.009L-89.1366 217.873C-89.7152 218.612 -90.4503 219.216 -91.2854 219.644L-61.8801 251.721Z",
    fill: "#9B9BCC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.928 31.4959C123.425 29.6802 127.59 29.6968 131.072 31.5404L181.605 58.293H68.3184L119.928 31.4959Z",
    fill: "#9B9BCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3184 58.293H181.605V111.185C181.605 117.813 176.232 123.185 169.605 123.185H80.3183C73.6909 123.185 68.3184 117.813 68.3184 111.185V58.293Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.526 96.3122L99.9972 110.759H105.121L105.455 108.895H102.815L105.714 90.1891H104.174L92.2728 106.952L94.6982 91.6979H93.2215L80.6814 108.834H78.5821L78.2168 110.759H82.0369L91.4136 97.9027L88.7896 113.286L90.3546 113.073L102.526 96.3122Z",
    fill: "#6C6B98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.546 89.0892L181.605 58.2929H68.3184L123.546 89.0892Z",
    fill: "#9B9BCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_225_18479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 21,
    width: 226,
    height: 134
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.001,
    cy: 88.0952,
    rx: 112.069,
    ry: 66.2066,
    fill: "#E5E7F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_225_18479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.225 98.6687L196.218 98.6646C198.907 91.845 196.078 84.0899 189.622 80.5825L157.042 62.0901C149.917 58.2208 141.005 60.8977 137.22 68.0535L137.12 68.2482C133.372 75.3204 136.065 84.0861 143.137 87.8583L175.823 106.16C183.501 110.253 193.035 106.755 196.225 98.6687Z",
    fill: "#FFEBD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.455 209.711C289.201 203.791 286.763 198.728 285.529 197.086L246.659 146.076C246.104 145.335 245.401 144.712 244.592 144.264L160.544 100.197C158.985 99.3272 157.346 97.0934 158.624 95.0017C161.497 90.2996 167.901 77.0858 170.778 71.7517C171.959 69.5614 174.234 69.8748 175.98 70.8618L266.083 118.793C266.793 119.19 267.418 119.722 267.937 120.35L314.072 175.357C314.664 176.086 315.41 176.676 316.253 177.088L287.455 209.711Z",
    fill: "#9B9BCC"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.557 78.9028C152.708 85.5702 144.182 87.8546 137.515 84.0052C132.611 81.1741 130.078 75.8137 130.613 70.5233C130.741 69.2586 129.688 68.0587 128.434 68.2639L124.698 68.875C123.894 69.0064 123.109 68.5532 122.821 67.7915L120.892 62.6887C120.604 61.9269 119.819 61.4738 119.016 61.6052L113.778 62.4618C112.911 62.6037 112.077 62.0652 111.849 61.2161L109.504 52.463C109.259 51.5503 109.801 50.6121 110.714 50.3675L114.724 49.293C115.162 49.1755 115.629 49.237 116.022 49.4639L134.905 60.3658C135.509 60.7143 136.258 60.6532 136.842 60.2715C141.103 57.4831 146.743 57.1401 151.455 59.8605C158.122 63.7099 160.407 72.2355 156.557 78.9028ZM147.269 77.5647C149.214 78.6874 151.701 78.0212 152.823 76.0765C153.946 74.1319 153.28 71.6452 151.335 70.5225C149.391 69.3997 146.904 70.066 145.781 72.0107C144.659 73.9553 145.325 76.442 147.269 77.5647Z",
    fill: "#6C6B98"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassSuccess);
export default __webpack_public_path__ + "static/media/forgot-pass-success.843e6d9011fa126c82057520afd5cfff.svg";
export { ForwardRef as ReactComponent };